import SiteHeader from '@/pages/home/components/SiteHeader';
import HeroSection from '@/pages/home/components/HeroSection';
import HotListSection from '@/pages/home/components/HotListSection';
import CategorySection from '@/pages/home/components/CategorySection';
import ArticlesSection from '@/pages/home/components/ArticlesSection';
import SpotlightSection from '@/pages/home/components/SpotlightSection';
import FaqSection from '@/pages/home/components/FaqSection';
import BrandSection from '@/pages/home/components/BrandSection';
import ContactSection from '@/pages/home/components/ContactSection';
import SiteFooter from '@/pages/home/components/SiteFooter';
import BackToTop from '@/pages/home/components/BackToTop';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <SiteHeader />
      <main>
        <HeroSection />
        <HotListSection />
        <CategorySection />
        <ArticlesSection />
        <SpotlightSection />
        <FaqSection />
        <BrandSection />
        <ContactSection />
      </main>
      <SiteFooter />
      <BackToTop />
    </div>
  );
}